import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../hooks/use-user-context';
import { createOptionMap } from '../utilities/misc';
import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { fontWeights } from '../theme/type';

const SkipLink = styled.a`
  left: -999px;
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;

  &:focus,
  &:active {
    padding: ${rem(10)} ${rem(18)};
    border-radius: ${rem(40)};
    font-weight: ${fontWeights.bold};
    font-size: ${rem(16)};
    line-height: 1.2;
    background: ${colors.blue['500']};
    color: ${colors.gray['50']};
    left: 0;
    top: 0;
    width: auto;
    height: auto;
    overflow: auto;
    margin: ${rem(20)};
    text-align: center;
    z-index: 999;
  }
`;

const SkipToMain = () => {
  const data = useStaticQuery(graphql`
    query SkipToMain {
      allContentfulOptionSet(filter: {name: {eq: "globals"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);

  return (
    <SkipLink href="#main">
      {options['globals.skip_to_main']}
    </SkipLink>
  );
};

export default SkipToMain;
